import React, { useId } from "react";
import PropTypes from "prop-types";

import { uiTokens } from "../../../../utils/uiTokens";

const DOLLAR_MARK_PATH =
  "M12 1C12.5523 1 13 1.44772 13 2V3.04549C14.5502 3.18762 15.9696 3.65724 17.0802 4.37517C18.4156 5.2385 19.4167 6.54973 19.4167 8.14815C19.4167 8.70043 18.969 9.14815 18.4167 9.14815C17.8644 9.14815 17.4167 8.70043 17.4167 8.14815C17.4167 7.45561 16.9813 6.69276 15.9944 6.05476C15.226 5.55802 14.1899 5.19012 13 5.05573V10.7226C14.932 10.7989 16.5472 11.1133 17.7461 11.7984C18.4666 12.2101 19.0458 12.7608 19.4377 13.47C19.8275 14.1752 20 14.979 20 15.8519C20 17.7763 18.9421 19.1185 17.4155 19.922C16.1904 20.5667 14.6434 20.8852 13 20.9737V22C13 22.5523 12.5523 23 12 23C11.4477 23 11 22.5523 11 22V20.9613C9.30461 20.829 7.75183 20.3632 6.54045 19.6453C5.11627 18.8014 4 17.4928 4 15.8519C4 15.2996 4.44772 14.8519 5 14.8519C5.55228 14.8519 6 15.2996 6 15.8519C6 16.5019 6.45074 17.2674 7.56005 17.9247C8.43919 18.4457 9.63204 18.8271 11 18.9541V12.6835C9.09913 12.6034 7.60805 12.2805 6.53338 11.6462C5.88559 11.2639 5.38266 10.7644 5.04894 10.1438C4.71768 9.52773 4.58333 8.84872 4.58333 8.14815C4.58333 6.54973 5.58436 5.2385 6.91983 4.37517C8.03038 3.65724 9.44975 3.18762 11 3.04549V2C11 1.44772 11.4477 1 12 1ZM11 5.05573C9.81011 5.19012 8.77403 5.55802 8.00563 6.05476C7.01873 6.69276 6.58333 7.45561 6.58333 8.14815C6.58333 8.59305 6.66774 8.93123 6.81044 9.19662C6.95067 9.45743 7.17691 9.70367 7.54996 9.92385C8.2131 10.3153 9.30242 10.6018 11 10.6814V5.05573ZM13 12.7245V18.9704C14.4191 18.8838 15.6183 18.6077 16.484 18.1521C17.4909 17.6222 18 16.8904 18 15.8519C18 15.2433 17.8809 14.7877 17.6873 14.4374C17.4959 14.0911 17.2001 13.7899 16.7539 13.5349C15.9639 13.0835 14.7447 12.8006 13 12.7245Z";

/**
 * Sidebar revenue / dollar mark — gradient matches shell sidebar icons (fuchsia → cyan).
 */
const RevenueIcon = ({ selected, width, height, className, ...props }) => {
  const id = useId().replace(/:/g, "");
  const gradientId = `revenue-dollar-gradient-${id}`;
  const isActive = selected;
  const gradStart = uiTokens.color.primitive.fuchsia[500];
  const gradEnd = uiTokens.color.primitive.cyan[500];

  return (
    <svg
      width={width || 24}
      height={height || 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      {...props}
    >
      <g opacity={isActive ? undefined : "0.5"}>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d={DOLLAR_MARK_PATH}
          fill={`url(#${gradientId})`}
        />
      </g>
      <defs>
        <linearGradient
          id={gradientId}
          x1="18.8923"
          y1="5.51783"
          x2="2.64021"
          y2="17.6936"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor={gradStart} />
          <stop offset="1" stopColor={gradEnd} />
        </linearGradient>
      </defs>
    </svg>
  );
};

RevenueIcon.propTypes = {
  selected: PropTypes.bool,
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  className: PropTypes.string,
};

RevenueIcon.defaultProps = {
  selected: false,
  width: undefined,
  height: undefined,
  className: "",
};

export default RevenueIcon;
